import { useRef, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import "./wallet-category.scss";

function WalletCategory({ value, setValue, loading }) {
    //general variables
    const { t } = useTranslation();

    //category list
    const categoryList = [
        {
            id: 1,
            type: "transactions",
            title: t("transactions"),
        },
        {
            id: 2,
            type: "creditRequests", 
            title: t("refundRequests"),
        },
    ];

    //filter category
    const categoryRef = useRef(null);

    const [valuePosition, setValuePosition] = useState(value || 1);
    
    // Update valuePosition when value prop changes (for initial load)
    useEffect(() => {
        setValuePosition(value);
    }, [value]);

    const filterCategory = (event, newValue) => {
        if (loading) return;

        setValuePosition(newValue);
        setValue(newValue);
    };

    return (
        <>
            <Grid 
                className="orders__categories" 
                container 
                item 
                xs={12} 
                justifyContent="center" 
                alignItems="center" 
                ref={categoryRef}
            >
                <span
                    className="orders__category-active"
                    style={{
                        insetInlineStart: valuePosition === 1 ? "0%" : "50%", // Fixed: swapped the positions
                        width: "50%", // Each category takes 50% width
                    }}
                ></span>
                {categoryList.map(categoryItem => {
                    return (
                        <Grid
                            className={`orders__category ${value === categoryItem.id ? "active" : ""}`}
                            key={categoryItem?.id}
                            container
                            item
                            xs={6} // Changed to xs={6} for 2 categories
                            justifyContent="center"
                            alignItems="center"
                        >
                            <Grid
                                container
                                item
                                xs={12}
                                columnGap={1}
                                justifyContent="center"
                                alignItems="center"
                                onClick={event => filterCategory(event, categoryItem.id)}
                                sx={{
                                    cursor: 'pointer',
                                    padding: '8px 4px', // Add some padding for better touch targets
                                    textAlign: 'center' // Ensure text is centered
                                }}
                            >
                                {categoryItem.title}
                            </Grid>
                        </Grid>
                    );
                })}
            </Grid>
        </>
    );
}

export default WalletCategory;